import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import App from './App';
import '../../design/partner-os/_ds/stakd-design-system-fbc41061-b917-40ab-9be4-a1a89dc58319/tokens/fonts.css';
import '../../design/partner-os/_ds/stakd-design-system-fbc41061-b917-40ab-9be4-a1a89dc58319/tokens/colors.css';
import '../../design/partner-os/_ds/stakd-design-system-fbc41061-b917-40ab-9be4-a1a89dc58319/tokens/typography.css';
import '../../design/partner-os/_ds/stakd-design-system-fbc41061-b917-40ab-9be4-a1a89dc58319/tokens/spacing.css';
import '../../design/partner-os/tokens/colors-light.css';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider><App /></AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
